import { render, staticRenderFns } from "./TipoViaje.vue?vue&type=template&id=af23b334"
import script from "./TipoViaje.vue?vue&type=script&lang=js"
export * from "./TipoViaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports